// extracted by mini-css-extract-plugin
export default {"categoryList":"CategoryList_categoryList__6-HTR","heading":"CategoryList_heading__2xsEK"};